export const fieldComponentMap = {
  'text': 'InputText',
  'textarea': 'Textarea',
  'number': 'InputNumber',
  'currency': 'InputNumber',
  'date': 'Calendar',
  'select': 'Dropdown',
  'clientAutocomplete': 'AppAutocomplete',
  'time': 'Calendar',
};

export const fieldTypeConfig = {
  'currency': {
    mode: 'currency',
    locale: 'pt-PT',
    minFractionDigits: 2,
  },
  'date': {
    dateFormat: 'dd/mm/yy',
    showIcon: true,
  },
  'time': {
    timeOnly: true,
    stepMinute: 15,
  },
  'number': {
    minFractionDigits: 0,
    maxFractionDigits: 2,
  },
};

export function getFieldProps(field) {
  const baseProps = {
    placeholder: field.placeholder || '',
    disabled: field.readonly || false,
  };

  switch (field.type) {
    case 'currency':
      return {
        ...baseProps,
        ...fieldTypeConfig.currency,
        currency: field.currency || 'EUR',
        min: field.min || 0,
      };

    case 'number':
      return {
        ...baseProps,
        ...fieldTypeConfig.number,
        min: field.min || 0,
        max: field.max,
      };

    case 'date':
      return {
        ...baseProps,
        ...fieldTypeConfig.date,
      };

    case 'time':
      return {
        ...baseProps,
        ...fieldTypeConfig.time,
      };

    case 'textarea':
      return {
        ...baseProps,
        rows: field.rows || 3,
        autoResize: field.autoResize || false,
      };

    default:
      return baseProps;
  }
}